import { B2bSwapDialog } from 'src/components/biz-b2b-swap-dialog';

export default B2bSwapDialog;
